<template>
  <div>
    <a-alert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <!-- filter -->
    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <ADatePicker
          style="width:100%;"
          :disabled-date="disabledStartDate"
          v-model:value="state.params.start_date"
          placeholder="Tanggal Awal Delivery"
          format="DD MMMM YYYY"
        >
          <template #suffixIcon>
            <ATooltip title="Tanggal Awal Delivery">
              <span
                role="img"
                aria-label="question-circle"
                type="primary"
                class="anticon anticon-question-circle"
                ><svg
                  focusable="false"
                  class=""
                  data-icon="question-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  viewBox="64 64 896 896"
                >
                  <path
                    d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                  ></path>
                  <path
                    d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                  ></path></svg
              ></span>
            </ATooltip>
          </template>
        </ADatePicker>
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <ADatePicker
          style="width:100%;"
          :disabled-date="disabledEndDate"
          v-model:value="state.params.end_date"
          placeholder=" Tanggal Akhir Delivery"
          format="DD MMMM YYYY"
        >
          <template #suffixIcon>
            <ATooltip title="Tanggal Akhir Delivery">
              <span
                role="img"
                aria-label="question-circle"
                type="primary"
                class="anticon anticon-question-circle"
                ><svg
                  focusable="false"
                  class=""
                  data-icon="question-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  viewBox="64 64 896 896"
                >
                  <path
                    d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                  ></path>
                  <path
                    d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                  ></path></svg
              ></span>
            </ATooltip>
          </template>
        </ADatePicker>
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <ADatePicker
          style="width:100%;"
          :disabled-date="disabledStartDateTrans"
          v-model:value="state.params.start_date_trans"
          placeholder=" Tanggal Awal Transaksi"
          format="DD MMMM YYYY"
        >
          <template #suffixIcon>
            <ATooltip title="Tanggal Awal Transaksi">
              <span
                role="img"
                aria-label="question-circle"
                type="primary"
                class="anticon anticon-question-circle"
                ><svg
                  focusable="false"
                  class=""
                  data-icon="question-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  viewBox="64 64 896 896"
                >
                  <path
                    d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                  ></path>
                  <path
                    d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                  ></path></svg
              ></span>
            </ATooltip>
          </template>
        </ADatePicker>
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <ADatePicker
          style="width:100%;"
          v-model:value="state.params.end_date_trans"
          :disabled-date="disabledEndDateTrans"
          placeholder=" Tanggal Akhir Transaksi"
          format="DD MMMM YYYY"
        >
          <template #suffixIcon>
            <ATooltip title="Tanggal Akhir Transaksi">
              <span
                role="img"
                aria-label="question-circle"
                type="primary"
                class="anticon anticon-question-circle"
                ><svg
                  focusable="false"
                  class=""
                  data-icon="question-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  viewBox="64 64 896 896"
                >
                  <path
                    d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                  ></path>
                  <path
                    d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                  ></path></svg
              ></span>
            </ATooltip>
          </template>
        </ADatePicker>
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterOpco style="width:100%;" v-model:value="state.params.opco" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterProvince style="width:100%;" v-model:value="state.params.provinsi" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterArea
          style="width:100%;"
          v-model:provinsi="state.params.provinsi"
          v-model:value="state.params.area"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterKabupatenKota
          style="width:100%;"
          v-model:provinsi="state.params.provinsi"
          v-model:area="state.params.area"
          v-model:value="state.params.kabupaten"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterBrand style="width:100%;" v-model:value="state.params.brand" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24" v-can:hide.distributor>
        <FilterDistributor
          style="width:100%;"
          v-model:distributor="state.params.distributor"
          v-model:area="state.params.area"
          v-model:provinsi="state.params.provinsi"
          v-model:kabupaten="state.params.kabupaten"
          v-model:value="state.params.distributor"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterSegment
          style="width:100%;"
          :mode="null"
          placeholder="Pilih Tipe Customer"
          v-model:value="state.params.type"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AInputSearch placeholder="Cari ..." v-model:value="state.params.q" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <AButton type="primary" title="cari" @click="fetchData" :loading="state.isFetching">
          <i class="fa fa-search" aria-hidden="true" v-if="!state.isFetching"></i>
          <span v-else>Memuat Data ...</span>
        </AButton>
      </ACol>
    </ARow>

    <div class="row justify-content-end">
      <div class="col-lg-6 col-md-12"></div>
      <div class="col-lg-6 col-md-12 text-right">
        <ASpace>
          <ATooltip title="Download Excel">
            <DownloadExcel
              :url="state.endpoint.current"
              :params="queryParams()"
              @errors="errorMessage"
            />
          </ATooltip>
        </ASpace>
      </div>
    </div>

    <!-- table lists -->
    <div class="table-responsive mt-4">
      <md-table
        :columns="state.columns"
        :data-source="state.data"
        size="small"
        :pagination="{
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
          showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
          total: state.meta.total,
          pageSize: state.meta.per_page,
          current: state.meta.page,
        }"
        :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        @change="handleTableChange"
        :loading="state.isFetching"
      >
        <template #no="{ index }">
          <span>
            {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
          </span>
        </template>
        <template #nilai="{ text }">
          <span>{{ text ? new Intl.NumberFormat('id-ID').format(text) : 0 }}</span>
        </template>
      </md-table>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, reactive } from 'vue'
import apiClient from '@/services/axios'
import FilterOpco from '@/components/filter/FilterOpco'
import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterArea from '@/components/filter/FilterArea'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import FilterBrand from '@/components/filter/FilterBrand'
import FilterSegment from '@/components/filter/FilterSegment'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import moment from 'moment'
import useUserInfo from '@/composables/useUserInfo'
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'

export default defineComponent({
  components: {
    FilterOpco,
    FilterProvince,
    FilterArea,
    FilterKabupatenKota,
    FilterDistributor,
    FilterBrand,
    FilterSegment,
    DownloadExcel,
  },
  setup() {
    const errorMessage = ref(null)
    const state = reactive({
      columns: [
        {
          title: 'NO',
          slots: { customRender: 'no' },
        },
        {
          title: 'Tanggal Transaksi',
          dataIndex: 'created_at_dist',
        },
        {
          title: 'Tanggal Delivery',
          dataIndex: 'tanggal',
        },
        {
          title: 'ID Toko',
          dataIndex: 'customer_code',
        },
        {
          title: 'Nama Toko',
          dataIndex: 'customer_name',
        },
        {
          title: 'Alamat Toko',
          dataIndex: 'customer_address',
        },
        {
          title: 'Kabupaten Toko',
          dataIndex: 'customer_kabupaten',
        },
        {
          title: 'Provinsi Toko',
          dataIndex: 'customer_propinsi',
        },
        {
          title: 'Area AP Toko',
          dataIndex: 'opco_toko',
        },
        {
          title: 'Area Toko',
          dataIndex: 'customer_area',
        },

        {
          title: 'Brands',
          dataIndex: 'brand_name',
        },
        {
          title: 'Kode Produk',
          dataIndex: 'product_code',
        },
        {
          title: 'Nama Produk',
          dataIndex: 'product_name',
        },
        {
          title: 'Harga',
          dataIndex: 'price',
          slots: { customRender: 'nilai' },
        },
        {
          title: 'Zak Quantity ',
          dataIndex: 'quantity_zak',
        },
        {
          title: 'UOM 1',
          dataIndex: 'uom1',
        },
        {
          title: 'TON Quantity ',
          dataIndex: 'quantity_ton',
        },
        {
          title: 'UOM 2',
          dataIndex: 'uom2',
        },
        {
          title: 'No Transaksi',
          dataIndex: 'transaksi_code',
        },

        {
          title: 'Kode Distributor',
          dataIndex: 'distributor_code',
        },
        {
          title: 'Nama Distributor',
          dataIndex: 'distributor_name',
        },
        {
          title: 'Kode Gudang ',
          dataIndex: 'warehouse_code',
        },
        {
          title: 'Nama Gudang ',
          dataIndex: 'warehouse_name',
        },
        {
          title: 'Area AP Gudang',
          dataIndex: 'opco_gudang',
        },
        {
          title: 'Provinsi Gudang',
          dataIndex: 'warehouse_propinsi',
        },
        {
          title: 'Area Gudang',
          dataIndex: 'warehouse_area',
        },
        {
          title: 'Kabupaten Gudang',
          dataIndex: 'warehouse_kabupaten',
        },
        {
          title: 'Tipe Customer',
          dataIndex: 'type_name',
        },
        {
          title: 'Cluster Pareto',
          dataIndex: 'cluster_name',
        },
        {
          title: 'SSM',
          dataIndex: 'user_ssm',
        },
        {
          title: 'ASM',
          dataIndex: 'user_sm',
        },
        {
          title: 'TSO',
          dataIndex: 'user_am',
        },
        {
          title: 'ID Salesman',
          dataIndex: 'salesman_id',
        },
        {
          title: 'Nama Salesman',
          dataIndex: 'salesman_name',
        },
        {
          title: 'Source System',
          dataIndex: 'source_system',
        },
      ],
      endpoint: {
        current: '/api/report/detail-trx-aksestoko',
      },
      data: [],
      isFetching: false,
      meta: {
        per_page: 10,
        page: 1,
        total: 0,
      },
      params: extractQueryParams({
        q: '',
        opco: [],
        area: [],
        provinsi: [],
        kabupaten: [],
        brand: [],
        distributor: [],
        type: [],
        start_date: moment(new Date()).startOf('month'),
        end_date: moment(new Date()),
        start_date_trans: null,
        end_date_trans: null,
        page: 1,
        'per-page': 2,
      }),
    })

    const handleTableChange = (page, filters, sorter) => {
      state.params.page = page.current
      state.params['per-page'] = page.pageSize

      fetchData()
    }

    const disabledStartDate = current => {
      return current && current > moment(state.params.end_date)
    }

    const disabledEndDate = current => {
      return current && moment(state.params.start_date) >= current
    }

    const disabledStartDateTrans = current => {
      return current && current > moment(state.params.end_date_trans)
    }

    const disabledEndDateTrans = current => {
      return current && moment(state.params.start_date_trans) >= current
    }

    const queryParams = () => {
      let params = state.params

      if (state.params.start_date) {
        state.params.start_date = moment(state.params.start_date).format('YYYY-MM-DD')
      }

      if (state.params.end_date) {
        state.params.end_date = moment(state.params.end_date).format('YYYY-MM-DD')
      }

      if (state.params.start_date_trans) {
        state.params.start_date_trans = moment(state.params.start_date_trans).format('YYYY-MM-DD')
      }

      if (state.params.end_date_trans) {
        state.params.end_date_trans = moment(state.params.end_date_trans).format('YYYY-MM-DD')
      }

      return updateUrlWithQuery(params)
    }

    const fetchData = () => {
      state.isFetching = true

      apiClient
        .get(state.endpoint.current, {
          params: queryParams(),
        })
        .then(({ data }) => {
          const { items, _meta } = data

          state.data = items
          state.meta.page = _meta.currentPage
          state.meta.per_page = _meta.perPage
          state.meta.total = _meta.totalCount
        })
        .finally(() => {
          state.isFetching = false
        })
    }

    onMounted(() => {
      const { isDistributor, isAm, vendor_id, areas } = useUserInfo()
      if (isDistributor.value) {
        state.params.distributor.push(vendor_id.value)
      }
      if (isAm.value) {
        areas.value.forEach(item => {
          state.params.area.push(item.id)
        })
      }

      fetchData()
    })

    return {
      handleTableChange,
      state,
      fetchData,
      errorMessage,
      queryParams,
      disabledStartDate,
      disabledEndDate,
      disabledStartDateTrans,
      disabledEndDateTrans,
    }
  },
})
</script>
